// src/config/analytics.ts
export const ANALYTICS_CONFIG = {
    CLARITY_PROJECT_ID: 'rtr0002lh8',
    GOOGLE_ANALYTICS_ID: '',
} as const;